import { Asset } from 'contentful'
import { Button } from '~/components/general/Button'
import { getContentfulAsset } from '~/libs/contentful/helpers'
export default function Cta({
  image,
  blockTitle,
  blockDescription,
  ctaText,
  ctaUrl,
}: {
  image: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined
  blockTitle: string
  blockDescription: string
  ctaText?: string
  ctaUrl?: string
}) {
  const imageEntry = getContentfulAsset(image)
  return (
    <div className="flex flex-col items-center bg-blue-10 h-fit gap-5 p-9 rounded-3xl top-25 max-lg:top-20 sticky min-w-[320px] max-md:hidden max-md:w-full max-md:gap-4 max-md:py-12 max-md:px-3">
      <img
        className="object-contain w-fit h-10 max-w-60"
        src={imageEntry?.fields?.file?.url}
        alt={imageEntry?.fields?.title}
      />
      <div
        style={{
          textAlign: 'center',
        }}
      >
        <h2 className="text-m text-blue-90">{blockTitle}</h2>
        <p className="text-xs text-blue-90 opacity-60 mt-3">{blockDescription}</p>
      </div>
      {ctaText && ctaUrl && (
        <Button text={ctaText} type={'link'} href={ctaUrl} className={'w-fit'} />
      )}
    </div>
  )
}
